/* Keep configured upsells in sync with Broadcast's native cart refresh. */
(() => {
  if (window.cartUpsellInitialized) return;
  window.cartUpsellInitialized = true;

  const updateCartUpsell = (cart) => {
    const wrappers = document.querySelectorAll('[data-cart-upsell]');
    if (!wrappers.length || !cart?.items) return;

    const productIdsInCart = new Set(cart.items.map((item) => String(item.product_id)));

    wrappers.forEach((wrapper) => {
      const products = wrapper.querySelectorAll('[data-cart-upsell-product]');
      let visibleCount = 0;

      products.forEach((product) => {
        const inCart = productIdsInCart.has(String(product.dataset.productId));
        product.hidden = inCart;

        if (!inCart) visibleCount += 1;
      });

      wrapper.hidden = visibleCount === 0;
    });
  };

  const fetchCartAndUpdateUpsell = () => {
    const cartUrl = window.Shopify?.routes?.root ? `${window.Shopify.routes.root}cart.js` : '/cart.js';

    fetch(cartUrl, {headers: {Accept: 'application/json'}})
      .then((response) => {
        if (!response.ok) throw new Error(`Cart upsell state failed: ${response.status}`);
        return response.json();
      })
      .then(updateCartUpsell)
      .catch((error) => console.log(error));
  };

  const getCartItems = () => document.querySelector('cart-items');

  const initializeNativeQuickAdd = (modal) => {
    const productInfo = modal?.querySelector('product-info');
    const productForm = productInfo?.querySelector('product-form');

    if (!productInfo || !productForm || !customElements.get('product-info')) return;

    productInfo.quantityInput = productInfo.querySelector('[data-quantity-input]');
    productInfo.productImages = productInfo.querySelector('product-images');
    productInfo.productMediaList = productInfo.querySelector('[data-product-media-list]');
    productInfo.productFormWrapper = productInfo.querySelector('[data-form-wrapper]');
    productInfo.productForm = productForm;

    if (productForm.form) return;

    // Complete Broadcast's native constructor setup after the dynamically
    // injected form children exist. Variant resolution remains fully native.
    productForm.form = productForm.querySelector('form');
    productForm.submitButton = productForm.querySelector('[type="submit"]');
    productForm.submitButtonText = productForm.submitButton?.querySelector('[data-add-to-cart-text]');

    if (!productForm.form || !productForm.submitButton || !productForm.variantIdInput) return;

    productForm.variantIdInput.disabled = false;
    productForm.form.addEventListener('submit', productForm.onSubmitHandler.bind(productForm));
    productForm.cart = document.querySelector('cart-drawer');
    productForm.hideErrors = productForm.dataset.hideErrors === 'true';

    if (productForm.cart) productForm.submitButton.setAttribute('aria-haspopup', 'dialog');
  };

  const showAddError = (button, data, upsell) => {
    const errors =
      upsell?.querySelector('[data-cart-errors-container]') ||
      button?.closest('dialog.product-quick-add--cart-upsell')?.querySelector('[data-cart-errors-container]');
    if (!errors) return;

    const message = data?.description || data?.message || 'Impossible d’ajouter ce produit au panier.';
    errors.innerHTML = `<div class="errors">${message}<button type="button" class="errors__close" data-close-error aria-label="Fermer">×</button></div>`;
    errors.classList.add('is-visible');
  };

  const refreshCartPage = () => {
    const cartItems = getCartItems();

    if (cartItems?.getCart) {
      cartItems.getCart();
    } else {
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', {bubbles: true}));
    }

    fetchCartAndUpdateUpsell();
  };

  const addCartPageUpsell = (event) => {
    const button = event.detail?.button;
    const page = document.querySelector('[data-cart-page]');
    const quickAddModal = button?.closest('dialog.product-quick-add--cart-upsell');
    const upsell =
      button?.closest('[data-cart-upsell-product]') ||
      (quickAddModal &&
        document.querySelector(
          `[data-cart-upsell-product][data-product-id="${quickAddModal.dataset.productId}"]`
        ));
    // On /cart, the upsell button is inside Broadcast's #cartForm. Do not use
    // button.form here: it resolves to the parent cart form, which has no id
    // field for this product. Variant modals still expose their native form.
    const form = button?.closest('form:not([data-cart-form])');

    if (!page || !upsell) return;

    // Broadcast redirects after a successful add when cart_type is "page".
    // Handle only this upsell event so the drawer and all other product forms stay native.
    event.preventDefault();
    event.stopImmediatePropagation();

    if (form && !form.checkValidity()) {
      form.reportValidity();
      return;
    }

    button.disabled = true;
    button.classList.add('is-loading');
    upsell.querySelector('.cart-upsell__holder')?.classList.add('is-visible');

    const cartRoot = window.Shopify?.routes?.root || '/';
    const addUrl = `${cartRoot}cart/add.js`;
    const formData = form ? new FormData(form) : new FormData();

    if (!form) {
      formData.append('id', button.dataset.cartUpsellVariantId);
      formData.append('quantity', '1');
    }

    fetch(addUrl, {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json',
      },
      body: formData,
    })
      .then(async (response) => {
        const data = await response.json();
        if (!response.ok || data.status) throw data;
        return data;
      })
      .then((data) => {
        updateCartUpsell({
          items: Array.isArray(data?.items) ? data.items : [data],
        });
        button.classList.add('is-added');
        document.dispatchEvent(
          new CustomEvent('theme:product:add', {
            detail: {response: data, button},
          })
        );
        refreshCartPage();
      })
      .catch((error) => {
        showAddError(button, error, upsell);
        button.disabled = false;
        button.classList.remove('is-loading');
        upsell.querySelector('.cart-upsell__holder')?.classList.remove('is-visible');
      });
  };

  document.addEventListener('theme:cart:add', addCartPageUpsell, true);

  document.addEventListener('theme:cart:change', (event) => {
    // Extension-triggered changes are followed by Broadcast's real cart refresh.
    if (event.detail?.source) return;

    if (event.detail?.cart?.items) {
      updateCartUpsell(event.detail.cart);
    } else {
      fetchCartAndUpdateUpsell();
    }
  });

  window.addEventListener(
    'theme:quick-add:open',
    (event) => {
      const modal = document.querySelector('dialog.product-quick-add--cart-upsell[open]');

      if (modal) {
        initializeNativeQuickAdd(modal);

        // Broadcast closes the cart drawer for regular quick-adds. Keep it open
        // only for this modal so it remains visible behind the upsell overlay.
        event.stopPropagation();
      }
    },
    true
  );

  fetchCartAndUpdateUpsell();
})();
